export const AllowAdminViewingAsClientRoutes = ['api/web-form/access'];
export const NotAllowedAdminViewingAsClientMethods = [
  'POST',
  'PUT',
  'DELETE',
  'PATCH',
];

export const NOT_ALLOWED_METHOD_ADMIN_VIEWING_AS_CLIENT_ERROR =
  'Operation not allowed: You are viewing as a client. ' +
  'Only read operations are allowed in this mode.';
